export const STEP_CART = "panier";
export const STEP_ACCOUNT = "compte";
export const STEP_ADDRESS = "adresse";
export const STEP_SHIPPING = "livraison";
export const STEP_CALENDAR = "calendar";
export const STEP_PRODUCT_COLLECTION = "collecte";
export const STEP_OPTIONS = "options";
export const STEP_PAYMENT = "paiement";
export const STEP_CONFIRM = "confirmation";
export const STEP_NO_SHIPPING = "livraison-indisponible";

export const STEPS = [
  STEP_CART,
  STEP_ACCOUNT,
  STEP_ADDRESS,
  STEP_SHIPPING,
  STEP_PRODUCT_COLLECTION,
  STEP_PAYMENT,
  STEP_CONFIRM,
];
export const STEPS_NAMES = ["Panier", "Compte", "Adresse", "Livraison", "Reprise", "Paiement"];

export const PERCENTAGE = "percentage";
export const FIXED = "fixed";
export const INSTALLATION = "installation";
export const SIDEWALK = "sidewalk";
export const ROOM = "room";
export const CLICK_AND_COLLECT = "click_and_collect";

export const SHIPPING_OPTIONS = [
  {
    type: SIDEWALK,
    title: "Livraison devant votre portail ou votre immeuble",
    titleMin: "Livraison devant votre portail ou votre immeuble",
    text: [". Choisissez un jour de livraison"],
    summaryText: "Frais de livraison",
  },
  {
    type: INSTALLATION,
    title: "Livraison et mise en service",
    titleMin: "Livraison et mise en service",
    text: [". Choisissez un créneau de livraison", ""],
    summaryText: "Frais de livraison",
  },
  {
    type: ROOM,
    title: "Livraison dans la pièce de votre choix",
    titleMin: "Livraison dans la pièce de votre choix",
    text: [". Choisissez un créneau de livraison", ""],
    summaryText: "Frais de livraison",
  },
  {
    type: CLICK_AND_COLLECT,
    title: "Click & Collect",
    titleMin: "Click & Collect",
    text: [". Choisissez un créneau de livraison", ""],
    summaryText: "Retrait en atelier",
  },
];

export const INCLUDED_IN_INSTALLATION = [
  {
    id: 1,
    text: "Positionnement de l'appareil dans son emplacement dégagé",
  },
  {
    id: 2,
    text: "Branchement (électrique et/ou arrivée d'eau/vidange) de l'appareil dans le respect des normes de sécurité",
  },
  {
    id: 3,
    text: "Vérification de son état de marche",
  },
];

export const NON_INCLUDED_IN_INSTALLATION = [
  {
    id: 1,
    text: "Pose des panneaux d'encastrement",
  },
  {
    id: 2,
    text: "Désinstallation de l'ancien appareil",
  },
  {
    id: 3,
    text: "Manipulation / travaux annexes sur l'appareil ou son environnement (perçage, démontage, branchement de rallonge, réglages d'utilisation...)",
  },
];

export const FAQ_URL =
  "https://murfy.zendesk.com/hc/fr/articles/4402175588626-Comment-savoir-ce-qui-est-compris-dans-mon-option-de-livraison-";

export const SLOTS = ["9h - 12h", "12h - 15h", "15h - 18h"];
